import { useContext, useEffect, useState } from "react";
import { Flex } from "@chakra-ui/react";
import { LoanContext } from "providers/loan";
import { LoanSignature } from "@common/loans/signatures/loan-signature.model";
import { SignatureSection } from "./signature-section";
import WidgetBox from "components/elements/WidgetBox/widget-box";
import { WidgetBoxActions } from "components/elements/WidgetBox/widget-box-actions";
import { ViewTermsButton } from "./view-terms-button";

interface SignaturesProps {
    showCoBorrowerSignature: boolean;
    onSignatureChange: (signatures: LoanSignature[]) => void;
}

const Signatures = ({
    showCoBorrowerSignature,
    onSignatureChange,
}: SignaturesProps) => {
    const { loan } = useContext(LoanContext);

    const [signature, setSignature] = useState<LoanSignature>();
    const [coSignature, setCoSignature] = useState<LoanSignature>();
    const [, setSignatures] = useState<LoanSignature[]>([]);

    useEffect(() => {
        if (loan) {
            setSignature(
                loan.signatures.find(
                    (signature) => signature.type === "borrower"
                )
            );

            setCoSignature(
                loan.signatures.find(
                    (signature) => signature.type === "co-borrower"
                )
            );

            setSignatures(loan.signatures);
        }
    }, [loan]);

    function handleSignatureChange(
        signature: LoanSignature,
        type: "borrower" | "co-borrower"
    ) {
        if (type === "borrower") {
            setSignature(signature);
        } else {
            setCoSignature(signature);
        }

        setSignatures((prev) => {
            const index = prev.findIndex((s) => s.id === signature.id);
            if (index !== -1) {
                prev[index] = signature;
            } else {
                prev.push(signature);
            }

            onSignatureChange(prev);
            return prev;
        });
    }

    return (
        <WidgetBox title="Signatures">
            <WidgetBoxActions>
                <ViewTermsButton />
            </WidgetBoxActions>
            <Flex gap={4}>
                <SignatureSection
                    type="borrower"
                    signature={signature}
                    onSignatureChange={(signature) =>
                        handleSignatureChange(signature, "borrower")
                    }
                />
                {showCoBorrowerSignature && (
                    <SignatureSection
                        type="co-borrower"
                        signature={coSignature}
                        onSignatureChange={(signature) =>
                            handleSignatureChange(signature, "co-borrower")
                        }
                    />
                )}
            </Flex>
        </WidgetBox>
    );
};

export default Signatures;
